import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText } = theme;

export const priceModifier = css`
  margin-left: auto;
  justify-self: flex-end;
  display: grid;
  grid-template-columns: 1fr 1fr;
  white-space: nowrap;
`;

export const priceOperator = css`
  ${responsiveText.BODY.SM};
  justify-self: flex-end;
  margin-right: ${pxToRem(2)};

  &[data-is-negative='false'] {
    ${responsiveText.HEADING.XS};
  }
`;
